module.exports = __webpack_public_path__ + "media/components/country-flag/static/cv-5a0ea9749fce0ce3b5bd29af5130e6a6.svg";